"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();

import React from "react"
import {
  ZESTLIFE_BLUE,
  ZESTLIFE_BLUE_BORDER,
  ZESTLIFE_BLUE_SOFT_BG,
  ZESTLIFE_HEAD_NAME,
  ZESTLIFE_HEAD_ROLE,
} from "../zestlifeDropdownTokens"

function initials(firstName?: string | null, lastName?: string | null) {
  const a = (firstName?.trim()?.[0] ?? "").toUpperCase()
  const b = (lastName?.trim()?.[0] ?? "").toUpperCase()
  const s = `${a}${b}`
  return s || "?"
}

export default function MenuMemberAndLeaderHeader({
  firstName,
  lastName,
}: {
  firstName?: string | null
  lastName?: string | null
}) {
  const displayName =
    [firstName, lastName].filter(Boolean).join(" ").trim() || "Account"

  return (
    <div className="flex min-w-0 max-w-full items-center gap-[10px] border-b-[0.5px] border-solid border-b-[rgba(0,0,0,0.12)] px-4 py-[14px]">
      <div
        className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full border border-solid text-[13px] font-medium"
        style={{
          backgroundColor: ZESTLIFE_BLUE_SOFT_BG,
          borderColor: ZESTLIFE_BLUE_BORDER,
          color: ZESTLIFE_BLUE,
        }}
      >
        {initials(firstName, lastName)}
      </div>
      <div className="min-w-0 flex-1 overflow-hidden">
        <p
          className="m-0 overflow-hidden text-[13px] font-medium leading-[1.25] text-ellipsis whitespace-nowrap"
          style={{ color: ZESTLIFE_HEAD_NAME }}
        >
          {displayName}
        </p>
        <p
          className="m-0 mt-px text-[11.5px] leading-[1.25]"
          style={{ color: ZESTLIFE_HEAD_ROLE }}
        >
          Provider account
        </p>
      </div>
    </div>
  )
}
